export default __webpack_public_path__ + "c5f310f9eebda9b0e58a06dc67a9fde2.wav";